export default __webpack_public_path__ + "static/media/01330000-6bec-ac1f-6098-08db2a9ed11c.1342aeb1.webp";